import { keyBy, mapValues } from 'lodash';
import { useSelector } from 'react-redux';
import { useAccount } from './index';

/**
 * get list of all clients
 * @param flat - send true if u want as array else return keyBy dictionary
 * @return {*|Dictionary<SP>}
 */
export const useClients = (flat = false) => {
  const clients = useSelector(
    ({ account }) =>
      account.clients?.map(
        ({ id, partyId, registeredName, businessName, businessCategory, ...restValues }) => ({
          id,
          partyId,
          registeredName,
          businessName,
          businessCategory,
          finalName: businessName || registeredName,
          ...restValues,
        })
      ) || []
  );

  return flat ? clients : keyBy(clients, 'id');
};

/**
 * get list of all service providers
 * @param flat - send true if u want as array else return keyBy dictionary
 * @return {*|Dictionary<SP>}
 */

export const useServiceProviders = (flat = false) => {
  const spList = useSelector(
    ({ serviceProvider }) =>
      serviceProvider.listLight.map(
        ({
          id,
          partyId,
          businessName,
          name,
          registeredName,
          fulfillmentcycle,
          mobile,
          email,
          vendorType,
          businessVertical,
          processingType,
          registeredAddress,
          ...restValues
        }) => ({
          id,
          partyId,
          finalName: businessName || registeredName,
          businessName,
          registeredName,
          name,
          fulfillmentcycle,
          mobile,
          email,
          vendorType,
          businessVertical,
          processingType,
          registeredAddress,
          ...restValues,
        })
      ) || []
  );
  return flat ? spList : keyBy(spList, 'id');
};

export const useServiceProvidersWithType = (flat = false) => {
  const spList = useSelector(
    ({ serviceProvider }) =>
      serviceProvider.listLight.map(
        ({
          id,
          businessName,
          fulfillmentcycle,
          mobile,
          email,
          vendorType,
          name,
          registeredName,
          ...restValues
        }) => ({
          id,
          businessName,
          finalName: businessName || registeredName,
          registeredName,
          fulfillmentcycle,
          mobile,
          email,
          vendorType,
          name,
          ...restValues,
        })
      ) || []
  );

  return flat ? spList : keyBy(spList, 'id');
};

/**
 * get all customers (myself, clients, sp)
 * @param flat - send true if u want as array else return keyBy dictionary
 * @return {*|Dictionary<SP>}
 */
export const useCustomers = (flat = false) => {
  const { myCustomerId } = useAccount();
  const serviceProviders = useServiceProviders();
  const clients = useClients();
  const self = { [myCustomerId]: { id: myCustomerId, finalName: 'Self', businessName: 'Self' } };
  const customers = { ...self, ...clients, ...serviceProviders };
  return flat ? mapValues(customers, (v, k) => v) : customers;
};

export const useRecyclers = () => {
  const recyclerList = useSelector(({ recyclers }) => recyclers.data);
  return recyclerList;
};
